import { Link } from 'react-router';
import { Store } from 'lucide-react';
import { cn } from '@/lib/cn';
import { useRecognitionDayOpen } from './useRecognitionDayOpen';

/**
 * TailAdmin-style topbar control: Store icon with a green/red corner badge for
 * the current scope's recognition-day session. Links to the sessions list.
 */
export function RecognitionDayIndicator() {
  const isOpen = useRecognitionDayOpen();

  const label =
    isOpen === true
      ? 'Recognition day open'
      : isOpen === false
        ? 'Recognition day closed'
        : 'Recognition day status';

  return (
    <Link
      to="/recognition-day-sessions"
      className={cn(
        'relative inline-flex h-9 w-9 items-center justify-center rounded-md text-gray-500 transition',
        'hover:bg-gray-100 hover:text-gray-900',
        'dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white',
      )}
      aria-label={label}
      title={label}
    >
      <Store className="h-5 w-5" aria-hidden="true" />
      <span
        className={cn(
          'absolute right-1.5 top-1.5 h-2 w-2 rounded-full ring-2 ring-white dark:ring-gray-950',
          isOpen === true && 'bg-emerald-500',
          isOpen === false && 'bg-red-500',
          isOpen === null && 'bg-gray-300 dark:bg-gray-600',
        )}
        aria-hidden="true"
      />
    </Link>
  );
}
